import create from 'zustand'
import { Country, HrSupportFeedbackTabFilter } from '../../../types'
import { HrSupportState, HrSupportTabs } from './types'
import { CascaderOptionType } from 'antd/lib/cascader'
import { hrSupportFeedbackTabInitialFilter } from './feedback/feedback-util'

const initialValues = {
  storeInitialized: false,
  activeTab: HrSupportTabs.feedback,
  selectableCountries: [] as CascaderOptionType[],
  selected: { label: '', value: '', key: '' } as CascaderOptionType,
  feedbackTabFilters: hrSupportFeedbackTabInitialFilter,
}

const sortAndMapCountries = (countries: Country[]) => {
  return countries
    .sort((c1, c2) => c1.localeCompare(c2))
    .map((country) => ({
      label: country,
      value: country,
      key: country,
    }))
}

export const useHrSupportStore = create<HrSupportState>((set) => ({
  ...initialValues,

  initStore: (selectableCountries: Country[]) =>
    set(() => {
      const sortedCountries = sortAndMapCountries(selectableCountries)

      const selectedCountry = sortedCountries[0]

      return {
        storeInitialized: true,
        activeTab: HrSupportTabs.feedback,
        selectableCountries: sortedCountries,
        selected: selectedCountry,
        feedbackTabFilters: hrSupportFeedbackTabInitialFilter,
      }
    }),

  setActiveTab: (activeTab: string) =>
    set((state) => {
      return {
        ...state,
        activeTab,
      }
    }),

  setSelected: (country: Country) =>
    set((state) => {
      return {
        ...state,
        selected: {
          label: country,
          value: country,
          key: country,
        },
      }
    }),

  setFeedbackTabFilters: (filters: HrSupportFeedbackTabFilter) =>
    set((state) => {
      return {
        ...state,
        feedbackTabFilters: filters,
      }
    }),
}))
